import { defineStore } from "pinia";
import { ref } from "vue";

const COLLAPSE_KEY = "hktada_admin_sidebar_collapsed";

export const useUIStore = defineStore("ui", () => {
  const sidebarCollapsed = ref(localStorage.getItem(COLLAPSE_KEY) === "1");
  const sidebarMobileOpen = ref(false);

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value;
    localStorage.setItem(COLLAPSE_KEY, sidebarCollapsed.value ? "1" : "0");
  }
  function toggleMobileSidebar() {
    sidebarMobileOpen.value = !sidebarMobileOpen.value;
  }
  function closeMobileSidebar() {
    sidebarMobileOpen.value = false;
  }

  return {
    sidebarCollapsed,
    sidebarMobileOpen,
    toggleSidebar,
    toggleMobileSidebar,
    closeMobileSidebar,
  };
});
